<div class="overly" (click)="closeModal()" *ngIf="modalControl?.showModal">
    <div class="popup-scroll-area">
        <div class="modal" (click)="$event.stopPropagation()">
            <header class="header">
                <div class="close-button" (click)="closeModal()">
                    <i class="ju ju-close"></i>
                </div>
                <span class="title">Liegenschaft</span>
            </header>

            <div class="modal-content">
                <div class="data-content">
                    <div class="card">
                        <div class="card-content">
                            <div class="sensor-row">
                                <div class="label">Kunde:</div>
                                <div class="value">
                                    {{ site.customerName || '-' }}
                                </div>
                            </div>
                            <div class="address">
                                <div class="address-title">Adresse:</div>
                                <div class="sensor-row">
                                    <div class="label">Straße*:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="site.street" required
                                               (ngModelChange)="editStreet($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Hausnummer*:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="site.streetNumber" required
                                               (ngModelChange)="editStreetNumber($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Postleitzahl*:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="site.postCode" required pattern="^\d{5}$"
                                               (ngModelChange)="editPostCode($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Stadt*:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="site.city" required
                                               (ngModelChange)="editCity($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Zusatzname:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="site.additionalName"
                                               (ngModelChange)="editAdditionalName($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Salesforce ID:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="site.salesforceId"
                                               (ngModelChange)="editSalesforceId($event)">
                                    </div>
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Ansprechpartner:</div>
                                <div class="value">
                                    <input type="text" [ngModel]="site.contactPersonName"
                                           (ngModelChange)="editContactPersonName($event)">
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Ansprechpartner Nr:</div>
                                <div class="value">
                                    <input type="text" [ngModel]="site.contactPersonNumber"
                                           (ngModelChange)="editContactPersonNumber($event)">
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Servicetechniker:</div>
                                <div class="value">
                                    <ng-select name="installationPersonEmail" id="installationPersonEmail"
                                               [clearable]="true"
                                               [(ngModel)]="site.installationPersonEmail"
                                               (ngModelChange)="editInstallationPersonEmail($event)">
                                        <ng-option *ngFor="let serviceTechnician of serviceTechnicians"
                                                   [value]="serviceTechnician.email">
                                            {{ serviceTechnician.email }}
                                        </ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Geplante KW:</div>
                                <div class="value">
                                    <input type="number" [ngModel]="site.installationWeek" pattern="^\d{1,2}$"
                                           [min]="1" [max]="53"
                                           (ngModelChange)="editInstallationWeek($event)">
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Notizen:</div>
                                <div class="value">
                                    <textarea [ngModel]="site.note"
                                              (ngModelChange)="editNotes($event)">
                                    </textarea>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="popup-footer">
                <button *ngIf="isPlanner" class="primary" [disabled]="!canSaveSite()" (click)="saveSite()">Speichern
                </button>
            </div>

            <div class="popup-footer">
                <button *ngIf="isPlanner" class="secondary" [disabled]="!canEdit()" (click)="closeModal()">Abbrechen
                </button>
            </div>
        </div>
    </div>
</div>
